<template>
  <div class="rf-detail-content-wrapper mt-4">
    <v-card class="p-0!">
      <v-tabs v-model="settingsTab" alignTabs="center" bgColor="#082638" height="70" dark>
        <v-tab v-if="userStore.isUserSuperAdmin" value="tab-1">
          <v-icon start>fa:fas fa-building</v-icon>
          <span class="v-tab--text">Custom Metrics</span>
        </v-tab>
        <v-tab v-if="userStore.isUserSuperAdmin" value="tab-2">
          <v-icon start>fa:fas fa-magic</v-icon>
          <span class="v-tab--text">AI Design Prompt</span>
        </v-tab>
      </v-tabs>
      <v-tabs-window v-model="settingsTab">
        <v-window-item v-if="userStore.isUserSuperAdmin" value="tab-1">
          <RfCustomMetrics />
        </v-window-item>
        <v-window-item v-if="userStore.isUserSuperAdmin" value="tab-2">
          <RfAiDesignPrompt />
        </v-window-item>
      </v-tabs-window>
    </v-card>
  </div>
</template>

<script setup>
import RfCustomMetrics from "@/components/RfSettings/RfCustomMetrics.vue";
import RfAiDesignPrompt from "@/components/RfSettings/RfAiDesignPrompt.vue";
import { useUserStore } from "@/pinia/userStore";
import { ref } from "vue";

const userStore = useUserStore();
const settingsTab = ref(null);
</script>
